import { IMessage } from "@/shared/types";

export enum VoiceConversationStatus {
  ACTIVE = "ACTIVE",
  STOPPED = "STOPPED",
  TIMEOUT = "TIMEOUT",
  IDLE = "IDLE",
}

interface IVoiceConversationConfig {
  session_hard_timeout_in_sec: number;
  session_idle_timeout_in_sec: number;
}

export interface IStartVoiceConversationParams {
  ai_chat_id: string;
  dialog_id?: string;
}

export interface IStartVoiceConversationResponse {
  conversation_id: string;
  status: VoiceConversationStatus;
  config: IVoiceConversationConfig;
  created_at: string;
}

export interface IProcessVoiceConversationParams {
  abortController: AbortController;
  conversation_id: string;
  audio: File;
}

export interface IProcessVoiceConversationResponse {
  audio: any;
  conversationId: string;
  conversationStatus: VoiceConversationStatus;
}

export interface IStopVoiceConversationParams {
  conversation_id: string;
}

export interface IStopVoiceConversationResponse {
  conversation_id: string;
  status: VoiceConversationStatus;
  message: IMessage;
}

export interface IVoiceConversationStatusParams {
  ai_chat_id: string;
  dialog_id: string;
}

export interface IVoiceConversationStatusResponse {
  conversation_id: string;
  dialog_id: string;
  status: VoiceConversationStatus;
  config: IVoiceConversationConfig;
  created_at: string;
}
